import { Description, Dialog, DialogHeader, Heading } from '@gitbook/spine-react';

import {
    CreateSiteSectionGroupForm,
    type CreateSiteSectionGroupFormProps,
} from './CreateSiteSectionGroupForm';

export interface CreateSiteSectionGroupDialogProps extends CreateSiteSectionGroupFormProps {}

export function CreateSiteSectionGroupDialog(props: CreateSiteSectionGroupDialogProps) {
    return (
        <Dialog>
            <DialogHeader>
                <Heading>Create group</Heading>
                <Description>
                    A group is a collection of sections to help organize your site structure. They
                    can be used to group related sections together, making it easier for users to
                    navigate your site.
                </Description>
            </DialogHeader>
            <CreateSiteSectionGroupForm {...props} />
        </Dialog>
    );
}
